import {useTranslation} from "react-i18next";
import {useNavigateTo} from "../../hooks/useNavigateTo";
import PC from "../PC";

export default function BreadCrumbs({ arr }) {
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();
  
  const jump = (path) => {
    if (path) navigateTo(path);
  };
  
  return (
    arr && arr.length > 0
      ? <PC className="py-[25px]">
        {
          arr.map((item, i) => (
            <a onClick={() => jump(item.path)}
               className={`${!item.path ? 'text-[#999] cursor-not-allowed' : 'cursor-pointer'}`}
               key={i}>{t(item.name)}
              <span className="px-[8px]">
              {i < arr.length - 1 ? ' > ' : ''}
              </span>
            </a>
          ))
        }
      </PC>
      : null
  );
}
